
<div class="row">
    <div class="col-lg-12 grid-margin">
      <div class="card">
        <div class="card-body upper-header" >
  
          <div class="filter-wrapper field_space" *ngIf = "changeForm">
            <form   [formGroup]="form" novalidate (ngSubmit)="saveData()">
              <div class="form-group col-12-div">
                <div class="form-group" style="width: 33%;">
                  <label >Mobile Number*</label>
                  <input
                  class="form-control border-primary"
                  formControlName="mobile_no"
                  name="mobile_no"
                  required
                  pattern="[0-9]*"
                  maxlength="10"
                  inputmode="numeric">
                
                </div>
              </div>
  
              ​<div class="button-wrap">
              <button  type="submit" [disabled]="!form.valid" class="btn btn-primary btn-fw">Submit</button>
              <button  type="button" class="btn btn-secondary btn-fw" (click)="close()">Close</button>
            </div>
  
            </form>
          </div>

          <div class="filter-wrapper field_space" *ngIf = "changeForm == false">
            <form   [formGroup]="formOtp" novalidate (ngSubmit)="saveOtpData()">
              <div class="form-group col-12-div">
                <div class="form-group" style="width: 33%;">
                  <label >Otp*</label>
                  <input
                  class="form-control border-primary"
                  formControlName="otp"
                  name="otp"
                  required
                  pattern="[0-9]*"
                  maxlength="4"
                  inputmode="numeric">
                </div>
              </div>
  
              ​<div class="button-wrap">
              <button  type="submit" [disabled]="!formOtp.valid" class="btn btn-primary btn-fw">Submit</button>
              <button  type="button" class="btn btn-secondary btn-fw" (click)="close()">Close</button>
            </div>
  
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  
  